import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Field, Control } from "rbx";
import Select from "react-select";

const OrderStatusFilter = ({ filters, handleSetFilters, options }) => {
  const [selected, setSelected] = useState(
    options.filter(opt => filters.StatusRecIdRef_in.some(x => opt.value === x))
  );

  const onChange = ({ target: { value } }) => {
    // eslint-disable-next-line no-unused-vars
    const { StatusRecIdRef_in, ...rest } = filters;
    if (Array.isArray(value) && value.length) {
      handleSetFilters({ ...rest, StatusRecIdRef_in: value });
    } else {
      handleSetFilters({ ...rest, StatusRecIdRef_in: [] });
    }
  };

  const handleChange = value => {
    setSelected(value);
    onChange({
      target: {
        name: "StatusRecIdRef_in",
        type: "select",
        value: Array.isArray(value) ? value.map(v => v.value) : null
      }
    });
  };

  useEffect(() => {
    setSelected(
      options.filter(opt =>
        filters.StatusRecIdRef_in.some(x => opt.value === x)
      )
    );
  }, [filters, options]);

  return (
    <div>
      <Field>
        <Control>
          <Select
            isMulti
            closeMenuOnSelect={false}
            name="StatusRecIdRef_in"
            options={options}
            value={selected}
            onChange={handleChange}
          />
        </Control>
      </Field>
    </div>
  );
};

OrderStatusFilter.propTypes = {
  filters: PropTypes.object,
  handleSetFilters: PropTypes.func,
  options: PropTypes.array
};

export default OrderStatusFilter;
